const Logo = ({ size = 32 }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32" 
      width={size} 
      height={size}
      style={{ display: 'block' }}
    >
      {/* Background */}
      <rect width="32" height="32" fill="var(--bg-tertiary)"/>
      
      {/* 3D S shape */}
      {/* Top bar */}
      <rect x="6" y="4" width="16" height="5" fill="var(--accent-primary)"/>
      {/* Top left drop */}
      <rect x="6" y="4" width="5" height="8" fill="var(--accent-primary)"/>
      {/* Middle bar */}
      <rect x="6" y="12" width="16" height="5" fill="var(--accent-primary)"/>
      {/* Bottom right drop */}
      <rect x="17" y="17" width="5" height="7" fill="var(--accent-primary)"/>
      {/* Bottom bar */}
      <rect x="6" y="23" width="16" height="5" fill="var(--accent-primary)"/>
      
      {/* 3D shadow */}
      <polygon points="22,4 26,7 26,12 22,9" fill="#1a1a2e"/>
      <polygon points="22,12 26,15 26,20 22,17" fill="#1a1a2e"/>
      <polygon points="22,23 26,26 26,31 22,28" fill="#1a1a2e"/>
      <polygon points="6,28 22,28 26,31 10,31" fill="#1a1a2e"/>
    </svg>
  );
};

export default Logo;
